import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { StarRatingStatic } from '../StarRating';
import { LINKS_COLOR, TEXT_COLOR } from '../../theme';
import media from '../../utils/mediaQueries';

const ReviewsLink = styled.a`
  color: ${LINKS_COLOR};
  margin-left: 13px;
  &:hover,
  &:focus,
  &:active {
    color: ${LINKS_COLOR};
  }
`;

const Title = styled.h2`
  font-size: 24px;
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: 0.2px;
  color: ${TEXT_COLOR};
  margin: 0 0 12px;

  ${media.mobile`
    font-size: 18px;
  `}
`;

const Header = ({ averageStars, reviewsCount, examCenterType }) => (
  <>
    <Title>{`Je passe mon code avec ${examCenterType} pour 30€`}</Title>
    <StarRatingStatic activeStarIdx={averageStars} height={16} width={17} />
    <ReviewsLink href="#avis">
      {`${reviewsCount} avis`}
    </ReviewsLink>
  </>
);

Header.propTypes = {
  averageStars: PropTypes.number.isRequired,
  reviewsCount: PropTypes.number.isRequired,
  examCenterType: PropTypes.string.isRequired,
};

export { Header };
